import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFilter, faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';

const Reportes4 = () => {
    // Datos de API
    const [reporteDatos, setReporteDatos] = useState([]);
    const [loading, setLoading] = useState(false);

    const getPrimerDiaMesActual = () => {
        const d = new Date();
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };
    const getUltimoDiaMesActual = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        return d.toISOString().split('T')[0];
    };

    const [fechaDesde, setFechaDesde] = useState(getPrimerDiaMesActual());
    const [fechaHasta, setFechaHasta] = useState(getUltimoDiaMesActual());
    const [profesional, setProfesional] = useState('');
    const [orden, setOrden] = useState('');

    useEffect(() => {
        cargarReporte();
    }, []);

    const cargarReporte = async () => {
        setLoading(true);
        try {
            const response = await authAxios.post('reportes/reportes_4', {
                fecha_inicial: fechaDesde,
                fecha_final: fechaHasta,
                profesional: profesional,
                orden: orden
            });
            if (response.data?.Status) {
                setReporteDatos(response.data.datos || []);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar los datos para el reporte', 'error');
            console.error(error);
        }
        setLoading(false);
    };

    const exportarExcel = () => {
        if (reporteDatos.length === 0) {
            Swal.fire('Atención', 'No hay datos para exportar', 'warning');
            return;
        }

        let excelData = [];
        reporteDatos.forEach(item => {
            excelData.push({
                "ID Liq": item.id || '-',
                "ID Orden": item.orden || '-',
                "Paciente": item.paciente || '-',
                "Profesional": (item.profesional_nombre + ' ' + item.profesional_apellido) || '-',
                "Atención": item.atencion || '-',
                "Cantidad": item.cantidad || 0,
                "Valor Und.": item.valor_und || 0,
                "Total": item.total || 0,
                "Fecha Registro": item.fecha_registro || '-',
                "Fecha Inicio": item.fecha_inicio || '-',
                "Fecha Final": item.fecha_final || '-'
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Liquidaciones");
        XLSX.writeFile(workbook, `Reporte_Liquidaciones_${new Date().toISOString().split('T')[0]}.xlsx`);
    };

    return (
        <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid pt-4">
                    {/* Tarjeta de Filtros */}
                    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white border-bottom">
                            <h4 className="card-title text-primary m-0" style={{ fontWeight: '600' }}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" />
                                Filtros - Reporte Liquidaciones
                            </h4>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3 align-items-end">
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Desde</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Hasta</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Profesional</label>
                                    <input type="text" className="form-control form-control-sm" placeholder="Nombre o apellido" value={profesional} onChange={e => setProfesional(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">ID Orden</label>
                                    <input type="number" className="form-control form-control-sm" placeholder="No. Orden" value={orden} onChange={e => setOrden(e.target.value)} />
                                </div>

                                <div className="col-md-3 text-end">
                                    <button className="btn btn-primary btn-sm w-100" onClick={cargarReporte} disabled={loading}>
                                        <FontAwesomeIcon icon={faSearch} className="me-1" /> Generar Reporte
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabla de Resultados */}
                    <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title m-0 fw-bold">Resultados del Reporte ({reporteDatos.length})</h5>
                            <div>
                                <button className="btn btn-success btn-sm" onClick={exportarExcel} disabled={loading || reporteDatos.length === 0}>
                                    <FontAwesomeIcon icon={faDownload} /> Exportar Excel
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped align-middle m-0" style={{ fontSize: '0.85rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID Liq.</th>
                                            <th className="text-center">Fecha Registro</th>
                                            <th>ID Orden</th>
                                            <th>Paciente</th>
                                            <th>Profesional</th>
                                            <th>Atención</th>
                                            <th className="text-center">Cant.</th>
                                            <th className="text-end">Valor Und.</th>
                                            <th className="text-end">Total</th>
                                            <th className="text-center">Fecha Inicio</th>
                                            <th className="text-center">Fecha Fin</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reporteDatos.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="text-center py-5">
                                                    {loading ? <div>Cargando datos...</div> : <div className="text-muted"><FontAwesomeIcon icon={faSearch} size="2x" className="mb-2 d-block mx-auto" /> No se encontraron resultados.</div>}
                                                </td>
                                            </tr>
                                        ) : (
                                            reporteDatos.map((item, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold">{item.id || '-'}</td>
                                                     <td>{item.fecha_registro || '-'}</td>
                                                    <td className="text-primary fw-bold">#{item.orden || '-'}</td>
                                                    <td>{item.paciente || '-'}</td>
                                                    <td className="fw-bold text-secondary">{item.profesional_nombre} {item.profesional_apellido}</td>
                                                    <td>{item.atencion || '-'}</td>
                                                    <td className="text-center">{item.cantidad || 0}</td>
                                                    <td className="text-end text-success">${Number(item.valor_und || 0).toLocaleString('es-CO')}</td>
                                                    <td className="text-end text-success fw-bold">${Number(item.total || 0).toLocaleString('es-CO')}</td>
                                                    <td className="text-center">{item.fecha_inicio || '-'}</td>
                                                    <td className="text-center">{item.fecha_final || '-'}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reportes4;
